import React from 'react';
import { ReceiptText } from 'lucide-react';
import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@roger/ui-components';
import type {
  ActiveBillingCycleItem,
  BillingCycleRemittanceLink,
} from '../../services/api/types.gen';
import { useEOEClaimsManagerNavigation } from './EOEClaimsManagerContext';

/**
 * Actions-cell icon that opens the remittance advice(s) matched to this
 * billing cycle's claims (EMR-2125). One advice opens the remittance detail
 * directly; several open the short chooser. Hidden when the cycle has no
 * live matched advice.
 */
export const RemittanceLinkAction: React.FC<{
  billingCycle: ActiveBillingCycleItem;
}> = ({ billingCycle }) => {
  const { openRemittance } = useEOEClaimsManagerNavigation();
  const remittances: BillingCycleRemittanceLink[] =
    billingCycle.remittances ?? [];
  if (remittances.length === 0) return null;
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type='button'
            variant='ghost'
            size='icon'
            onClick={() => openRemittance(remittances)}
            className='text-muted-foreground hover:text-foreground'
            aria-label='View remittance'
          >
            <ReceiptText className='h-4 w-4' />
          </Button>
        </TooltipTrigger>
        <TooltipContent side='bottom' className='text-xs'>
          View remittance
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
